import { useState, FormEvent } from "react";
import axios from "../../services/axios/backendAxios";
// eslint-disable-next-line no-restricted-imports
import * as baseAxios from "axios";
import AsyncSelect from "react-select/async";
// import { User } from "../../types";
import SubtleButton from "../../components/Buttons/SubtleButton";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { invalidateQueriesContaining } from "../../utils/queryInvalidation";
import flash from "../../services/flash";
import { AdminCompanySelect } from "./AddUserToCompany";
import errors from "../../services/errors";
import { User } from "@mysnowscape/snow-lib";
type FormPayload = {
  company_id: string;
  new_owner_id: string;
};
export default function TransferOwnership() {
  const queryClient = useQueryClient();
  const [selectedUser, setSelectedUser] = useState<User | null>(null);
  const save = useMutation({
    mutationFn: (data: FormPayload) => {
      return axios.post(`company/developer/transfer-ownership`, data);
    },
    onSuccess: (resp) => {
      flash.success(resp?.data?.message ?? "Ownership transferred.");
    },
    onSettled: () => {
      invalidateQueriesContaining(queryClient, [
        "company",
        "companies",
        "user",
      ]);
    },
    onError: (err) => {
      if (baseAxios.isAxiosError(err)) {
        const details = err.response?.data;
        flash.error(details.message ?? "Error transferring ownership");
      } else {
        flash.error("Error saving: " + (err.message ?? err));
        errors.report(err);
      }
    },
  });
  return (
    <div>
      <h2 className="text-lg font-bold">Transfer Ownership</h2>
      <p className="text-xs text-gray-700">
        New owner must have a stripe subscription (Han Solo is fine) and be an
        admin on the company before ownership can be transferred. If you want to
        keep the old stripe account, you will need to do that manually.
      </p>
      <form
        onSubmit={(e: FormEvent<HTMLFormElement>) => {
          e.preventDefault();
          if (confirm("Transfer ownership?")) {
            const form = e.currentTarget as HTMLFormElement;
            const formData = new FormData(form);
            const data = Object.fromEntries(formData.entries()) as FormPayload;
            console.log(data);
            save.mutate(data);
          }
        }}
        className="grid grid-cols-1 gap-2"
      >
        <label>
          <span className="text-xs text-gray-500">Company To Transfer</span>
          <AdminCompanySelect name="company_id" />
        </label>
        <label>
          <span className="text-xs text-gray-500">New Owner</span>
          <UserSelect
            name="new_owner_id"
            onChange={(user) => setSelectedUser(user)}
          />
        </label>
        <SubtleButton type="submit" className="mt-2" loading={save.isPending}>
          Transfer Ownership
        </SubtleButton>
      </form>
    </div>
  );
}

export function UserSelect({
  name,
  onChange,
}: {
  name: string;
  onChange: (user: User | null) => void;
}) {
  const [selectedUser, setSelectedUser] = useState<User | null>(null);
  const loadOptions = async (inputValue: string) => {
    if (!inputValue || inputValue.length < 3) return [];
    const res = await axios.get(
      `/user/developer/list?q=${encodeURIComponent(inputValue)}`,
    );
    const data = await res.data;
    const users = data.users as User[];
    return users.map((u) => ({
      label: `${u.firstName} ${u.lastName} (${u.phoneNumber})`,
      value: u._id,
      raw: u,
    }));
  };
  return (
    <AsyncSelect
      name={name}
      cacheOptions
      defaultOptions={false}
      loadOptions={loadOptions}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onChange={(option: any) => {
        setSelectedUser(option ? option.raw : null);
        onChange(option ? option.raw : null);
      }}
      placeholder="Search users (min 3 chars)..."
      // Render the menu into a portal so it isn't clipped by parent overflow
      // Use a runtime check for `document` so SSR won't break
      menuPortalTarget={
        typeof document !== "undefined" ? document.body : undefined
      }
      menuPosition="fixed"
      styles={{
        control: (baseStyles) => ({
          ...baseStyles,
          borderColor: "#829399",
        }),
        // ensure the portal'd menu is drawn above other content
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
      }}
      value={
        selectedUser
          ? {
              label: `${selectedUser.firstName} ${selectedUser.lastName} (${selectedUser.phoneNumber})`,
              value: selectedUser._id,
            }
          : null
      }
      isClearable
    />
  );
}
